package com.schoolconnect.app.feature.reports

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier

@Composable
fun ReportsFeatureRoute(
    modifier: Modifier = Modifier
) {
    val viewModel = remember { ReportsViewModel() }
    DisposableEffect(Unit) {
        onDispose { viewModel.clear() }
    }
    val state by viewModel.uiState.collectAsState()
    ReportsScreen(
        state = state,
        rows = viewModel.resultRows(),
        onEvent = viewModel::onEvent,
        modifier = modifier
    )
}
